<template>
  <div class="album-page">
    <div class="album-title">{{ $t('albumName') }}</div>

    <div class="waterfall-container">
      <waterfall height="100%" :col="2" :data="mediaList">
        <div v-for="(item, index) in mediaList" :key="item.id || index" class="album-item" @click="openPreview(item)">
          <!-- 视频封面逻辑 -->
          <div v-if="item.type === 'video'" class="video-cover">
            <img :src="item.image" alt="cover" />
            <div class="play-icon">▶</div>
          </div>

          <!-- 图片逻辑 -->
          <img v-else :src="item.image" alt="photo" />
        </div>
      </waterfall>
      <!-- <div class="bottom-spacer" /> -->
    </div>

    <PreviewViewer v-if="previewVisible" :list="mediaList" :index="currentIndex" @close="previewVisible = false" />
  </div>
</template>

<script>
import PreviewViewer from './PreviewViewer.vue'

export default {
  components: {
    PreviewViewer
  },

  data() {
    return {
      previewVisible: false,
      currentIndex: 0,
      mediaList: [
        // {
        //   id: '1',
        //   type: 'image',
        //   image: require('../../../assets/images/picsum/1.png')
        // },
        // {
        //   id: '2',
        //   type: 'image',
        //   image: require('../../../assets/images/picsum/2.jpg')
        // },
        // {
        //   id: '3',
        //   type: 'image',
        //   image: require('../../../assets/images/picsum/3.jpg')
        // },
        // {
        //   id: '4',
        //   type: 'image',
        //   image: require('../../../assets/images/picsum/4.jpg')
        // },
        // {
        //   id: '5',
        //   type: 'image',
        //   image: require('../../../assets/images/picsum/5.jpg')
        // },
        // {
        //   id: '6',
        //   type: 'image',
        //   image: require('../../../assets/images/picsum/6.jpg')
        // },
        // {
        //   id: '7',
        //   type: 'image',
        //   image: require('../../../assets/images/picsum/7.jpg')
        // },
        // {
        //   id: '8',
        //   type: 'video',
        //   image: require('../../../assets/images/picsum/8.jpg'),
        //   url: require('../../../assets/images/picsum/9.mp4')
        // }
      ]
    }
  },

  methods: {
    openPreview(item) {
      this.currentIndex = this.mediaList.findIndex((v) => v.id === item.id)
      this.previewVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.album-page {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  padding: 2.4vh 3vw;
  background: #f7f7f7;
}

.waterfall-container {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding-bottom: 2.4vh;
  box-sizing: border-box;
}

.bottom-spacer {
  height: 2vh;
}

.album-title {
  flex-shrink: 0;
  z-index: 100;
  background: transparent;
  padding: 1.4vh 0 2vh;
  margin-bottom: 1.2vh;
  font-size: 4.6vw;
  font-weight: 700;
  color: #222;
  letter-spacing: 0.02em;
}

.album-item {
  cursor: pointer;
  overflow: hidden;
  min-height: 100px;
  border-radius: 2.4vw;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  &:not(:last-child) {
    margin-bottom: 1.6vh;
  }

  img {
    width: 100%;
    display: block;
    padding: 0.8vw;
    box-sizing: border-box;
    border-radius: 2.4vw;
  }
}

.video-cover {
  position: relative;
  width: 100%;
  border-radius: 2.4vw;
  overflow: hidden;

  img {
    width: 100%;
    display: block;
    padding: 0.8vw;
    box-sizing: border-box;
    border-radius: 2.4vw;
  }
}

.play-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 10vw;
  height: 10vw;
  max-width: 54px;
  max-height: 54px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4vw;
  pointer-events: none;
}
</style>
